export class ItemBasicInfo {
  equipId: number;
  assetId: number;
  eventSiteId: number;
  locationSiteId: number;

  public static fromJson(itemBasicInfoJson: any): ItemBasicInfo {
    return Object.assign(new ItemBasicInfo(), itemBasicInfoJson);
  }
}
